import React, { useState, useEffect } from 'react';
import Sidebar_Progress from "../../../layouts/Admin_Sidebar_Progress.component";
import LoginHeaderOperational from './../../LoginHeaderOperational';
import Loader from './../../Employee/Loader.component';
import { fetchPumpLockDates, fetchPumpNames, savePumpLockDates } from '../adminApi';

const SetPump = (props) => {
	const [pageState, setPageState] = useState('loading');
	const [input, setInput] = useState({});
	const [permission, setPermission] = useState({});
	const [dropdownData, setDropdownData] = useState([]);
	const [lockStartDate, setLockStartDate] = useState('');
	const [lockEndDate, setLockEndDate] = useState('');
	const [saveMessage, setSaveMessage] = useState(null);
	const [loadError, setLoadError] = useState(null);

	const handleChange = (e) => {
		const pumpId = e.target.value;
		if (pumpId) {
			localStorage.setItem('admin_pump_id', pumpId);
		} else {
			localStorage.removeItem('admin_pump_id');
		}
		setInput({ ...input, pump_id: pumpId });
		setSaveMessage(null);
		if (pumpId) {
			loadLockDates(pumpId);
		} else {
			setLockStartDate('');
			setLockEndDate('');
		}
	};

	useEffect(() => {
		loadPumpList();
	}, []);

	function loadLockDates(pumpId) {
		fetchPumpLockDates(pumpId)
			.then((data) => {
				if (data.status) {
					setLockStartDate(data.ac_loc_sys_start_date || '');
					setLockEndDate(data.ac_loc_sys_end_date || '');
				}
			})
			.catch(() => {});
	}

	function loadPumpList() {
		const token = localStorage.getItem('AUTH_TOKEN');
		if (!token) {
			setLoadError('Session expired. Please log in again.');
			setPageState('error');
			return;
		}

		setPageState('loading');
		setLoadError(null);

		fetchPumpNames()
			.then((responseData) => {
				if (responseData.status === 3) {
					setPermission({
						status: responseData.status,
						message: responseData.message,
					});
					setPageState('ready');
					return;
				}

				const storedPumpId = localStorage.getItem('admin_pump_id');
				if (storedPumpId) {
					setInput((prev) => ({ ...prev, pump_id: storedPumpId }));
					loadLockDates(storedPumpId);
				}

				const datas = (responseData.pump_detail || []).map((emp) => [emp.id, emp.pump_name]);
				setDropdownData(datas);
				setPageState('ready');
			})
			.catch((error) => {
				setLoadError(error.message || 'Failed to load pumps.');
				setPageState('error');
			});
	}

	function handleSave() {
		const pumpId = input.pump_id || localStorage.getItem('admin_pump_id');
		if (!pumpId) {
			setSaveMessage({ type: 'error', text: 'Please select a pump first.' });
			return;
		}
		setSaveMessage(null);
		savePumpLockDates(pumpId, lockStartDate, lockEndDate)
			.then((data) => {
				if (data.status) {
					setSaveMessage({ type: 'success', text: data.message || 'Saved successfully.' });
				} else {
					setSaveMessage({ type: 'error', text: data.message || 'Save failed.' });
				}
			})
			.catch((error) => {
				setSaveMessage({ type: 'error', text: error.message || 'Save failed.' });
			});
	}

	return (
		<>
			<div className="main-container page-wrap">
				<div className="d-md-flex">
					<Sidebar_Progress props={props} progress={1} operation={1} />
					<div className="content-area">
						<LoginHeaderOperational props={props} page_title="" />
						<div className="container pb-3">
							{pageState === 'loading' ? <Loader /> : null}

							{permission.status === 3 ? (
								<div className="form-wrap mt-5">
									<div className="text-center">{permission.message}</div>
								</div>
							) : pageState === 'error' ? (
								<div className="form-wrap mt-5">
									<div className="text-center text-danger">{loadError}</div>
									<div className="text-center mt-3">
										<button type="button" className="btn btn-primary" onClick={loadPumpList}>
											Retry
										</button>
									</div>
								</div>
							) : pageState === 'ready' ? (
								<div className="row mt-md-5 mt-3 form-container justify-content-center">
									<div className="col-md-9">
										<div className="form-wrap ">
											<div className="row mb-3 justify-content-center">
												<div className="col-md-12 col-12 pl-0 mb-4">
													<h3 className="table-title text-center">Pump Change </h3>
												</div>
												<div className="col-md-7">
													<div className="row mb-2 align-items-center">
														<div className="col-md-4 text-end"><label className="mb-0">Pump Name</label></div>
														<div className="col-md-8">
															<select
																className="form-control highlight"
																name="pump_id"
																value={input.pump_id || ''}
																onChange={handleChange}
															>
																<option value="">select</option>
																{dropdownData.map((data) => (
																	<option key={data[0]} value={data[0]}>{data[1]}</option>
																))}
															</select>
														</div>
													</div>
													<div className="row mb-2 align-items-center">
														<div className="col-md-4 text-end"><label className="mb-0">Locking system start date</label></div>
														<div className="col-md-8">
															<input
																type="date"
																className="form-control highlight"
																value={lockStartDate}
																onChange={(e) => setLockStartDate(e.target.value)}
															/>
														</div>
													</div>
													<div className="row mb-2 align-items-center">
														<div className="col-md-4 text-end"><label className="mb-0">End date</label></div>
														<div className="col-md-8">
															<input
																type="date"
																className="form-control highlight"
																value={lockEndDate}
																onChange={(e) => setLockEndDate(e.target.value)}
															/>
														</div>
													</div>
													<div className="row mb-2 align-items-center">
														<div className="col-md-4"></div>
														<div className="col-md-8">
															<button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
															{saveMessage && (
																<span className={saveMessage.type === 'success' ? 'text-success ms-3' : 'text-danger ms-3'}>
																	{saveMessage.text}
																</span>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SetPump;
